import { instance } from "libs/api";

import { ApiRoutesMarketing } from "../../constants";
import { GetMarketingContactResponse } from "../../marketing.types";

export const requestGetMarketingContact = async (
  phone: string
): Promise<GetMarketingContactResponse> => {
  return await instance.get(
    `${ApiRoutesMarketing.Contacts}/${encodeURIComponent(phone)}`
  );
};
